import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CgpAlertDialogService, cgpAlertTypes } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { BatchJobMaintenanceModalService } from './batch-job-maintenance-modal.service';


const BATCH_JOB_CONFIRMATION = 'Batch Job Confirmation';
const BATCH_JOB_SUCCESSFUL = 'Batch Job Successful';
const BATCH_JOB_UNSUCCESSFUL = 'Batch Job Unsuccessful';
@Component({
   selector: 'abatch-job-maintenance-modal',
   templateUrl: './batch-job-maintenance-modal.component.html',
   styleUrls: ['./batch-job-maintenance-modal.component.scss']
})
export class BatchJobMaintenanceModalComponent implements OnInit {
   value = 0;
   loading = false;

   constructor(
      private readonly batchJobMaintenanceModalService: BatchJobMaintenanceModalService,
      private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
      private readonly cgpAlertDialogService: CgpAlertDialogService,
   ) { }

   ngOnInit() { }

   onDailyWarningProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'Early warning reminder (Daily) Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getDailyWarningProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For Early Warning Reminder (Daily) Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For Early Warning Reminder (Daily) Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  }
               );

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onWeeklyWariningProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'Early warning reminder (Weekly) Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getWeeklyWariningProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For Early Warning Reminder (Weekly) Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For Early Warning Reminder (Weekly) Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onUserProfileUpdateProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'User Profile Update Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getUserProfileUpdateProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For User Profile Update Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For User Profile Update Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onQuoteAutoDeleteProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'ADM001/Trash File Cleanup Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getQuoteAutoDeleteProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For ADM001/Trash File Cleanup Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For ADM001/Trash File Cleanup Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onTmacsProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'TMACS Update Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getTmacsProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For TMACS Update Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For TMACS Update Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onTprMetricProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'TPR Metric Reminder Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getTprMetricProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For TPR Metric Reminder Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For TPR Metric Reminder Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

   onProdFileAutoDeleteProcessClick() {
      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: BATCH_JOB_CONFIRMATION,
         message: `Do you want to run this batch job?`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.cgpAlertDialogService.showAlertDialog({
               title: 'PRD040 File Cleanup Batch Job',
               message: 'Job is initiated. You will be notified upon completion',
               alert: cgpAlertTypes.success,
               closeLabel: 'OK'
            });
            this.batchJobMaintenanceModalService.getProdFileAutoDeleteProcess()
               .pipe(finalize(() => this.loading = false))
               .subscribe(
                  res => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_SUCCESSFUL,
                        message: 'Batch Job For Prd040 File Cleanup Ran Successfully!',
                        alert: cgpAlertTypes.success,
                        closeLabel: 'OK'
                     });
                  },
                  error => {
                     this.cgpAlertDialogService.showAlertDialog({
                        title: BATCH_JOB_UNSUCCESSFUL,
                        message: 'Batch Job For Prd040 File Cleanup Did Not Run Successfully! Please try again!',
                        alert: cgpAlertTypes.danger,
                        closeLabel: 'OK'
                     });
                  },
                  () => {
                     this.loading = false;
                  });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()
      });
   }

}
